import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

// @ts-expect-error TODO: исправить импорт картинок
import userImg from './assets/user.svg';
import * as styles from './styles.css';

type TUserCardProfileLink = {
  userProfileUrl: string;
};

export const UserCardProfileLink: React.VFC<TUserCardProfileLink> = ({ userProfileUrl }) => {
  return (
    <a href={userProfileUrl} className={styles['profile_button']} data-testid="UserCardProfileLink" target="_blank">
      <img src={userImg} width={24} height={24} />
      <UIText3 color="primary_100">Профиль</UIText3>
    </a>
  );
};
